import ActivateAccountForm from "../../forms/ActivateAccountForm";

export default function ActivateAccount() {
  return <ActivateAccountForm />;
}
